import React from 'react';
import moment from 'moment';
import ReportDropDown from '../../components/reportDropDown';
import {SearchField} from 'components';
import {trublueClaimStatusesFormat, reportDateFormat} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';
import CustomerApi from 'api/customer';

import events from '../../../../../lib/events.js';

import EditableDatePicker from '../../../../components/forms/editableDatePicker.jsx';

class TrublueClaimsOptions extends React.Component {
  state = {
  };

  componentWillMount() {
    let {formatMessage} = this.props.intl;
    
    this.resetFilters();

    this.trublueClaimStatuses = [];
    this.trublueClaimStatusNames = trublueClaimStatusesFormat(formatMessage);

    this.trublueClaimStatuses = Object.keys(this.trublueClaimStatusNames).map((key) => {
      return {value: key, label: this.trublueClaimStatusNames[key]};
    });
  }

  updateData = () => {
    this.props.updateReportData(
        moment(this.state.dateFrom).format(dateTimeFormats.numeralDate),
        moment(this.state.dateTo).format(dateTimeFormats.numeralDate),
        this.state.customer,
        this.state.trublueClaimStatus,
    );
  };

  updateDates = (data) => {
    if(data.key === 'dateFrom') {
      if(this.validateDates(data.value, this.state.dateTo)) {
        this.setState({
          dateFrom: data.value,
        });
      }
    } else if(data.key === 'dateTo') {
      if(this.validateDates(this.state.dateFrom, data.value)) {
        this.setState({
          dateTo: data.value,
        });
      }
    }
  };

  search = (data) => {
    this.setState({customer: undefined});
    CustomerApi.getCustomers(data)
      .then(results => {
        const filter = results.filter.toLowerCase();

        this.setState({
          customerOptions: results.rows.slice(0,6).map(customer => {
            const filterIndex = customer.name.toLowerCase().indexOf(filter);

            return {
              key: customer.Id && customer.Id.split('.')[0],
              value: customer.name,
              start: filterIndex >= 0 ? customer.name.slice(0, filterIndex) : customer.name,
              match: filterIndex >= 0 ? customer.name.slice(filterIndex, filterIndex + filter.length) : '',
              end: filterIndex >= 0 ? customer.name.slice(filterIndex + filter.length) : '',
            };
          }),
        });
      });
  }

  resetFilters() {
    let filters = this.props.defaultFilters;

    this.setState({
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
      customer: filters.search,
      trublueClaimStatus: filters.status,
    }, () => {
      this.customerSearch._setValue(this.state.customer);
    });
  }

  validateDates = (dateFrom, dateTo) => {
    if(moment(dateFrom).isAfter(dateTo)) {
      events.publish('error.user', {
        message: this.props.intl.formatMessage({id: 'general.error.invalid.dates'}),
        key: 'invalidDates',
      });
      return false;
    }
    return true;
  };

  render() {
    let {formatMessage} = this.props.intl;

    return (
      <div className="report-options" >
        <div className="top-title-bar" >
          <FormattedMessage id="general.report.options" />
        </div>
        <div className="select-options container-fluid">
          <div className="row">
            <div className="col-sm-3">
              <div className='form-group'>
                <label><FormattedMessage id="general.date.from" /></label>
                <EditableDatePicker
									onChange={this.updateDates}
									dataKey='dateFrom'
									value={this.state.dateFrom}
									maxDate={moment(this.state.dateTo).clone().subtract(1, 'days')}
									editMode={true}
									dateFormat={reportDateFormat} />
              </div>
            </div>
            <div className="col-sm-3">
              <div className='form-group'>
                <label><FormattedMessage id="general.date.to" /></label>
                <EditableDatePicker
									onChange={this.updateDates}
									dataKey='dateTo'
									value={this.state.dateTo}
									minDate={moment(this.state.dateFrom).clone()}
									maxDate={moment()}
									editMode={true}
									dateFormat={reportDateFormat} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-9">
              <div className="form-group">
                <label><FormattedMessage id="trublue.claims.customer" /></label>
                <SearchField
                  ref={s => this.customerSearch = s}
                  onSearch={this.search}
                  typeahead
                  typeaheadOptions={this.state.customerOptions}
                  onSelected={(option) => this.setState({customer: option.key})}
                  placeholder={this.props.intl.formatMessage({id: 'general.search.special.character'})}
                  autoFocus={false}
                  minCharacters={0} />
              </div>
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.trublueClaimStatus} label={formatMessage({id: 'general.status'})}
							onChange={((e) => {
  this.setState({trublueClaimStatus: e.target.value});
})}
							options={this.trublueClaimStatuses} />
            </div>
          </div>
        </div>
        <div className="manage-options">
          <div className="col-sm-12 button-group">
            <a className="reset-button pull-right" onClick={() => this.resetFilters()}><FormattedMessage id="general.reset" /></a>
            <a className="btn btn-primary pull-right" onClick={this.updateData}><FormattedMessage id="reports.update.summary" /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(TrublueClaimsOptions);
